module.exports = __webpack_public_path__ + "static/media/ek-min.9944b5f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/ek-min.svg
// module id = 688
// module chunks = 0